import * as styles from './ListItemContentContainer.module.css'

function ListItemContentContainer({
  children,
  className = styles.ListItemContentContainer,
}) {
  return <div className={className}>{children}</div>
}

export default ListItemContentContainer
